import { FunctionComponent } from 'react';

import NewImage from 'components/layout/NewImage';

import { Props } from './index';
import StyledComponent from './styles';

const PublicBlogsArticleAuthor: FunctionComponent<Props> = ({
    article,
    translations,
}) => {
    if (!article?.author) return null;
    return (
        <StyledComponent className="public-blogs-article-author">
            {article?.author?.avatar && (
                <NewImage
                    className="author-avatar"
                    resizerConfig={{ width: 200 }}
                    fileUpload={article?.author?.avatar}
                    alt={article?.author?.name}
                />
            )}
            <div className="author-info">
                <div className="author-name">
                    {article?.author?.name}
                </div>
                {article?.author?.specialization && (
                    <div className="author-specializtion">
                        <span className="title">
                            {translations?.specializtionTitle}
                        </span>
                        {' '}
                        <span className="subtitle">
                            {article?.author?.specialization}
                        </span>
                    </div>
                )}
                {article?.author?.bio && (
                    <div className="author-bio">
                        <span className="title">{translations?.bioTitle}</span>
                        {' '}
                        {article?.author?.bio}
                    </div>
                )}
            </div>
        </StyledComponent>
    );
};

export default PublicBlogsArticleAuthor;
